import { useContext } from 'react'

import { MainContext } from 'src/providers/Main'

export const useMainContext = () => useContext(MainContext)
